jQuery(document).ready(function () {
  jQuery("body.single .anchor-menu").each(function () {
    var $this = jQuery(this);

    if ($this.find("div.lnk").length > 1) {
      jQuery(window).scroll(function () {
        var distanceFromTop = jQuery(document).scrollTop();
        var container = jQuery("body.single .anchor-menu");

        if (distanceFromTop >= 200) {
          //user scrolled far from the top
          container.addClass("show");
        } else if (container.hasClass("show")) {
          jQuery("body.single .anchor-menu").removeClass("show");
        }
      });
      // console.log("Lots of li. Finish.");
    } else {
      // console.log("Less than 1 li. Finish.");
    }
  });

  
});

jQuery("body.single .anchor-list").slick({
  infinite: false,
  slidesToShow: 6,
  slidesToScroll: 2,
  dots: false,
  speed: 1000,
  autoplay: false,
  autoplaySpeed: 2000,
  centerMode: false,
  arrows: true,
  variableWidth: true,
  accessibility: false,
  responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

jQuery(function () {
  setTimeout(
    function () {
      jQuery('.anchor-list a, .anchor-list button').attr('tabindex', '-1');
    }, 200);
});




jQuery(document).on('click', '#commentaryJump', function (event) {
  event.preventDefault();

  topMenu = jQuery("#anchorList");
  headerHeight = jQuery('.header').outerHeight() + 1;
  topMenuHeight = topMenu.outerHeight() + 1;
  offsetHeight = +headerHeight + +topMenuHeight;

  jQuery('html, body').animate({
    scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - offsetHeight
  }, 500, "swing");
});

jQuery(document).on('click', 'a.skip-to-content-link', function (event) {
  event.preventDefault();

  headerHeight = jQuery('header').outerHeight() + 1;
  offsetHeight = +headerHeight;

  jQuery('html, body').animate({
    scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - offsetHeight
  }, 500, "swing");
});


jQuery(document).on('click', 'article a[href^="#"]', function (event) {
  event.preventDefault();

  topMenu = jQuery("#anchorList");
  headerHeight = jQuery('.header').outerHeight() + 1;
  topMenuHeight = topMenu.outerHeight() + 1;
  offsetHeight = +headerHeight + +topMenuHeight;

  jQuery('html, body').animate({
    scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - offsetHeight
  }, 500, "swing");
});

jQuery(document).on('click', '#backToTop', function (event) {
  event.preventDefault();
  jQuery('html, body').animate({
    scrollTop: 0
  }, 500, "swing");
  jQuery('.skip-to-content-link').focus();
});


jQuery( window ).scroll(function() {
  var distanceFromTop = jQuery(document).scrollTop();
  if (distanceFromTop >= 600) {
    jQuery("#backToTop").addClass("show");
  } else {
    jQuery("#backToTop").removeClass("show");

  }
});

